
<template>
  <div class="all-wrapper solid-bg-all">
    <div class="layout-w">
        <TopBarComponent/>
      <AsideComponent/>
      <div class="content-w" style="height: 100%; min-height: 700px;">

        <div class="layout-w">
          <AsideMovilComponent/>

          <div class="content-w pt-md-5">
            <div class="content-i">
            <router-view/>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
        <!-- /.site-footer -->
      </div>
      <!--Version /-->
      <!-- /#right-panel -->
    </div>
  </div>
</template>

<script>
import AsideComponent from "@/layouts/globals/AsideComponent.vue";
import AsideMovilComponent from "@/layouts/globals/AsideMovilComponent.vue";
import TopBarComponent from "@/layouts/globals/TopBarComponent.vue";
// import Version from "@/components/globals/Version.vue";

export default {
  components: {
    AsideComponent,
    TopBarComponent,
    AsideMovilComponent
    // Version
  },
  data: () => ({
    drawer: null
  }),
  props: {
    source: String
  },
  created() {
    $("body").removeClass("auth-wrapper");
    $("body").addClass("menu-side-left");
    $("body").addClass("menu-position-side");
  },
};
</script>

<style lang="scss">
</style>
